import { render, staticRenderFns } from "./attrValueList.vue?vue&type=template&id=3a46f11e&scoped=true"
import script from "./attrValueList.vue?vue&type=script&lang=js"
export * from "./attrValueList.vue?vue&type=script&lang=js"
import style0 from "./attrValueList.vue?vue&type=style&index=0&id=3a46f11e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46f11e",
  null
  
)

export default component.exports